import { FEATURE_FLAGS } from '@constants';
import { useLaunchDarkly } from '~/composables/useLaunchDarkly';

type FeatureFlagKey = keyof typeof FEATURE_FLAGS;

/**
 * Named middleware that gates a page behind a LaunchDarkly feature flag.
 *
 * Usage in definePageMeta:
 *   definePageMeta({ middleware: ['feature-flag'], featureFlag: 'DEVELOPER_PLATFORM' })
 *
 * The featureFlag value should be a key from the FEATURE_FLAGS constant (e.g. 'DEVELOPER_PLATFORM').
 */
export default defineNuxtRouteMiddleware(to => {
  const flagConstantKey = to.meta.featureFlag as FeatureFlagKey | undefined;
  if (!flagConstantKey) return;

  const flagKey = FEATURE_FLAGS[flagConstantKey];
  if (!flagKey) return;

  const { getFlag } = useLaunchDarkly();

  if (!getFlag(flagKey, false)) {
    return navigateTo('/');
  }
});
